<template>
  <div class="news-content-container">
    <back-open-chenter />
    <div class="news-content-panel">
      <div class="news-title">腾讯云：率先支持DeepSeek全系模型精调与推理</div>
      <div class="news-date">2025年2月21日</div>
      <div class="news-content">
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/ai_logo.gif"/>
          </div>
        </div>
        <p>
          近日，腾讯云旗下TI平台宣布支持
          <span class="mark-text highlight">DeepSeek「全系模型」</span>
          的企业级精调与推理，帮助开发者更好解决「数据预处理难」、「模型训练门槛高」、「在线部署及运维复杂」等问题。
        </p>
        <p>
          此次支持能够为
          <span class="mark-text highlight">金融、医疗、制造、零售</span>
          等多个行业提供更高效、更便捷的AI模型构建及应用方案，进一步降低企业在大模型应用中的技术门槛和研发成本。
        </p>
        <p>目前，用户可以根据个性化需求，灵活使用两种精调模式：</p>
        <div class="news-content-mark">
          <div>模式一：直接精调满血版DeepSeek</div>
        </div>
        <p>适用于希望直接对原始DeepSeek模型进行微调的用户，两步走即可完成精调。</p>
        <p>
          <span class="mark-text">● 步骤一：训练数据准备</span>
        </p>
        <p>在数据标注环节，可基于灵活Schema配置得到高度自定义的人工标注工作台，适配绝大多数标注场景；在数据构建环节，用户内置数据分析、清洗、去重、Prompt优化、格式转换等环节的代码脚本，支持用户灵活处理各类文本数据。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/newscenter/news69.webp"/>
          </div>
        </div>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news69/news69_1.webp"/>
          </div>
        </div>
        <p>
          <span class="mark-text">● 步骤二：一键发起模型精调</span>
        </p>
        <p>在“大模型广场”或者“任务式建模”模块选择DeepSeek模型；选择步骤一中准备的数据路径，设置学习率、迭代步数等参数，即可发起训练任务。支持全参和LoRA两种策略，供用户按需选择精调场景。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news69/news69_2.png"/>
          </div>
        </div>
        <div class="news-content-mark">
          <div>模式二：基于DeepSeek R1蒸馏其他较小尺寸模型</div>
        </div>
        <p>适用于希望以更低成本、更高响应速度应用R1的用户。TI平台支持基于R1蒸馏其他较小尺寸模型，可将R1的能力迁移至较小尺寸的“学生”模型中。三步走迅速实现精调。</p>
        <p>
          <span class="mark-text">● 步骤一：部署DeepSeek-R1推理服务</span>
        </p>
        <p>在腾讯云TI平台的在线服务模块部署 DeepSeek R1推理服务，体验对话效果。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news69/news69_3.png"/>
          </div>
        </div>
        <p>
          <span class="mark-text">● 步骤二：基于 DeepSeek-R1 蒸馏数据</span>
        </p>
        <p>在数据构建模块中将原始训练数据集进行解析、清洗，然后调用DeepSeek R1生成高质量带长思维链的蒸馏数据，并对蒸馏数据再次进行分析、清洗、去重、Prompt优化、格式转换等环节，得到可用于训练的数据集。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news69/news69_4.png"/>
          </div>
        </div>
        <p>
          <span class="mark-text">● 步骤三：精调较小尺寸的“学生模型”</span>
        </p>
        <p>在“大模型广场”或者“任务式建模”模块选择Llama等其他较小尺寸的“学生模型”；选择步骤二中准备的数据路径，设置学习率、迭代步数等参数，即可发起训练任务。</p>
        <div>
          <div class="image-panel">
            <img class="news-image" src="../img/detail/Information/news69/news69_5.png"/>
          </div>
        </div>
        <p>为确保模型在实际应用中的稳定性与高效性，腾讯云TI平台还提供了全面的「模型评测」与「部署功能」，以全流程能力保障模型优化。</p>
        <p>
          值得一提的是，TI平台同时支持
          <span class="mark-text highlight">公有云、私有化版本</span>
          。其中，公有云版本在腾讯云上开箱即用，按需订阅；私有化版本可部署在客户本地机房、专属云服务器等自有算力上，更适合金融等更高数据安全要求的场景，从而灵活满足政府和企业的多样化需求。
        </p>
        <p>快来腾讯云TI平台，训练一个属于你的专属模型吧！</p>
        <p>获取<a href="https://cloud.tencent.com/document/product/851/116195">「使用DeepSeek-R1蒸馏其他模型的全流程实践」</a>。</p>
      </div>
    </div>
  </div>
</template>

<script>
import BackOpenChenter from '@/components/open/panels/news/detail/BackOpenChenter';
export default {
  name: 'News67',
  components: {
    BackOpenChenter
  }
};
</script>

<style lang="less" scoped>
@import "./news.less";
.news-content {
  margin: 0 auto;
  .image-panel {
    max-width: 667px;
    text-align: center;
    img {
      max-width: 667px;
    }
    span {
      font-size: 12px;
      color: #858585;
    }
  }
  .highlight {
    color: #0052FF;
  }
  .end-divide {
    width: 120px;
    height: 2px;
    margin: 20px auto;
    background: #0152d9;
  }
  .download-article-wrap {
    margin: 0 auto;
    padding: 5px 3px;
    border: 3px solid rgb(1, 82, 217);
    font-family: PingFangSC-light;
    .download-article {
      padding: 5px 10px;
      border-left: 1px solid rgb(1, 82, 217);
      border-right: 1px solid rgb(1, 82, 217);
    }
  }
  .right-text {
    font-size: 12px;
    text-align: right;
    color: #0152d9;
  }
  .news-literature {
    max-height: 180px;
    padding: 15px;
    overflow-y: scroll;
    background-color: #ebebeb;
  }
  .short-center{
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/open/panels/news/detail/News69.vue